import logo from "../Assets/icons/logo_tix.png";
import bhd from "../Assets/img/img_showtime/bhd.png";
import cinestar from "../Assets/img/img_showtime/cinestar.png";
import lotte from "../Assets/img/img_showtime/lotte.png";
import mega from "../Assets/img/img_showtime/mega.png";
import ddc from "../Assets/img/img_showtime/ddc.png";
import dcine from "../Assets/img/img_showtime/dcine.jpg";
import banner_1 from "../Assets/img/img_banner/chong-nguoi-ta-16053546067770.png";
import banner_2 from "../Assets/img/img_banner/bhd-star-59k-ve-ca-tuan-16045660915386.jpg";
import banner_3 from "../Assets/img/img_banner/bi-mat-cua-gio-sneakshow-16056745070206.jpg";
import banner_4 from "../Assets/img/img_banner/dong-gia-1k-ve-khi-mua-ve-qua-tix-16043766276410.jpg";
import banner_5 from "../Assets/img/img_banner/tiec-trang-mau-blood-moon-party-16021267739246.png";
import banner from "../Assets/img/banner.jpeg";
import zion from "../Assets/img/img_partners/zion.jpeg";
import boCongThuong from "../Assets/img/img_partners/bocongthuong.png";
import khungIphone from "../Assets/img/img_mobile/iphone.png";
import slider_1 from "../Assets/img/img_mobile/slider1.jpeg";
import slider_2 from "../Assets/img/img_mobile/slider2.jpeg";
import slider_3 from "../Assets/img/img_mobile/slider3.jpeg";
import slider_4 from "../Assets/img/img_mobile/slider4.jpeg";
import slider_5 from "../Assets/img/img_mobile/slider5.jpeg";
import slider_6 from "../Assets/img/img_mobile/slider6.jpeg";
import slider_7 from "../Assets/img/img_mobile/slider7.jpeg";
import slider_8 from "../Assets/img/img_mobile/slider8.jpeg";
import slider_9 from "../Assets/img/img_mobile/slider9.jpeg";
import slider_10 from "../Assets/img/img_mobile/slider10.jpeg";
import slider_11 from "../Assets/img/img_mobile/slider11.jpeg";
import slider_12 from "../Assets/img/img_mobile/slider12.jpeg";
import slider_13 from "../Assets/img/img_mobile/slider13.jpeg";
import rap1 from "../Assets/img/img_showtime/rap1.jpg";
import rap2 from "../Assets/img/img_showtime/rap2.jpg";
import rap3 from "../Assets/img/img_showtime/rap3.jpg";
import rap4 from "../Assets/img/img_showtime/rap4.jpg";
import rap5 from "../Assets/img/img_showtime/rap5.jpg";
import star from "../Assets/img/star.png";
import dummyImg from "../Assets/img/dummyDataa/dummyData.jpeg";
import bgImg from "../Assets/img/img__moviedetail/list_bg.jpg";
import bgImg1 from "../Assets/img/img__moviedetail/bgImg.jpeg";
import xoay from "../Assets/img/img__moviedetail/xoay.png";
import nen from "../Assets/img/img__moviedetail/nen.png";
import imgUser from "../Assets/img/cz.jpeg";
import imgNotToken from "../Assets/img/imgNotToken.png";
import cgv from "../Assets/img/img_partners/cgv.png";
import galaxy from "../Assets/img/img_partners/galaxy.png";
import lottecinema from "../Assets/img/img_partners/lottecinema.png";
import beta from "../Assets/img/img_partners/beta.jpeg";
import touch from "../Assets/img/img_partners/touch.png";
import cinemax from "../Assets/img/img_partners/cinemax.jpeg";
import starLight from "../Assets/img/img_partners/starlight.png";
import zalopay from "../Assets/img/img_partners/zalopay.png";
import payoo from "../Assets/img/img_partners/payoo.jpeg";
import vietcombank from "../Assets/img/img_partners/vietcombank.png";
import argibank from "../Assets/img/img_partners/argibank.png";
import vietinbank from "../Assets/img/img_partners/vietinbank.png";
import ivb from "../Assets/img/img_partners/ivb.png";
import go123 from "../Assets/img/img_partners/red.png";
import laban from "../Assets/img/img_partners/laban.png";
import apple from "../Assets/img/img_partners/apple.png";
import android from "../Assets/img/img_partners/android.png";
import facebook from "../Assets/img/img_partners/facebook.png";
import zalo from "../Assets/img/img_partners/zalo.png";
import buttonPlay from "../Assets/img/img_movie/play.png";
import news1 from "../Assets/img/img_celebrity/hinh-nho-1.jpeg";
import news2 from "../Assets/img/img_celebrity/hinh-nho-2.png";
import news3 from "../Assets/img/img_celebrity/hinh-nho-3.png";
import news4 from "../Assets/img/img_celebrity/hinh-nho-4.png";
import like from "../Assets/img/img_celebrity/like.png";
import comment from "../Assets/img/img_celebrity/comment.png";
import pic1 from "../Assets/img/img_celebrity/hinh1.jpeg";
import pic2 from "../Assets/img/img_celebrity/hinh2.png";
import pic3 from "../Assets/img/img_celebrity/hinh3.jpg";
import pic4 from "../Assets/img/img_celebrity/hinh4.png";
import screen from "../Assets/img/screen.png";
import carousel1 from "../Assets/img/img_banner/carousel1.png";
import carousel2 from "../Assets/img/img_banner/carousel2.png";
import carousel3 from "../Assets/img/img_banner/carousel3.png";
import catCry from "../Assets/img/cat_cry.jpeg";
import backNews from "../Assets/img/back-new.png";
import dropdown from "../Assets/img/img_banner/dropdown.png";
import poster from "../Assets/img/img_movie/poster.jpeg";
import dos from "../Assets/img/img_partners/dos.jpeg";
import visa from "../Assets/img/img_partners/visa.png";
import cover from "../Assets/img/img_inforuser/cover.jpeg";
import ticket from "../Assets/img/ticket.png";
import defaultFilm from "../Assets/img/dummyDataa/defaultFilm.jpeg";
import dummyImgMovie from "../Assets/img/img_movie/bi-mat-cua-gio.png"
import star1 from "../Assets/img/star1.png";
export default {
  logo,
  bhd,
  cinestar,
  lotte,
  mega,
  ddc,
  dcine,
  banner_1,
  banner_2,
  banner_3,
  banner_4,
  banner_5,
  banner,
  zion,
  boCongThuong,
  khungIphone,
  slider_1,
  slider_2,
  slider_3,
  slider_4,
  slider_5,
  slider_6,
  slider_7,
  slider_8,
  slider_9,
  slider_10,
  slider_11,
  slider_12,
  slider_13,
  rap1,
  rap2,
  rap3,
  rap4,
  rap5,
  star,
  bgImg,
  bgImg1,
  xoay,
  nen,
  dummyImg,
  imgUser,
  imgNotToken,
  cgv,
  galaxy,
  lottecinema,
  beta,
  touch,
  cinemax,
  starLight,
  zalopay,
  payoo,
  vietcombank,
  argibank,
  vietinbank,
  ivb,
  go123,
  laban,
  apple,
  android,
  facebook,
  zalo,
  buttonPlay,
  news1,
  news2,
  news3,
  news4,
  like,
  comment,
  pic1,
  pic2,
  pic3,
  pic4,
  screen,
  carousel1,
  carousel2,
  carousel3,
  catCry,
  backNews,
  dropdown,
  poster,
  dos,
  visa,
  cover,
  ticket,
  defaultFilm,
  dummyImgMovie,
  star1,
};
